/**
 * HESTIA sticky ATC — syncs with on-page QB options and reuses the primary ATC button
 * so cart/add + gift logic stays in one path (fast + no double-add bugs).
 */
(function () {
  var bar = null;
  var btn = null;
  var opts = null;
  var visible = false;
  var syncing = false;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function findQbRadios() {
    return qsa('.quantity-break-input, input.quantity-break-input[type="radio"]');
  }

  function findPrimaryAtc() {
    return (
      qs('button[name="add"]:not([disabled])') ||
      qs('form[action*="/cart/add"] button[type="submit"]') ||
      qs('[data-hestia-atc], .product-form__submit, .pdp-add-to-cart button')
    );
  }

  function mapOptToRadio(key) {
    var radios = findQbRadios();
    if (!radios.length) return null;
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var row = r.closest('.quantity-break-option, .quantity-break-option-container, label, [class*="qb"]');
      var text = ((row && row.textContent) || '').toLowerCase();
      var val = (r.value || r.id || r.name || '').toLowerCase();
      var isB1g3 =
        text.indexOf('get 3') !== -1 ||
        text.indexOf('b1g3') !== -1 ||
        text.indexOf('buy 1 get') !== -1 ||
        val.indexOf('b1g3') !== -1 ||
        val.indexOf('get3') !== -1;
      var isBuy1 =
        !isB1g3 &&
        (text.indexOf('buy 1') !== -1 ||
          text.indexOf('1 stick') !== -1 ||
          val.indexOf('buy1') !== -1 ||
          i === 0);
      if (key === 'b1g3' && isB1g3) return r;
      if (key === 'buy1' && isBuy1) return r;
    }
    // Fallback: first = buy1, last/second = b1g3
    if (key === 'buy1') return radios[0];
    return radios[radios.length - 1];
  }

  function setStickyActive(key) {
    if (!opts) return;
    opts.forEach(function (el) {
      var on = el.getAttribute('data-hestia-sticky-opt') === key;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function selectBundle(key, fromPage) {
    if (syncing) return;
    syncing = true;
    setStickyActive(key);
    if (!fromPage) {
      var radio = mapOptToRadio(key);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        var row = radio.closest('.quantity-break-option, label');
        if (row) {
          row.classList.add('selected');
          // deselect siblings
          var parent = row.parentElement;
          if (parent) {
            qsa('.quantity-break-option, label', parent).forEach(function (sib) {
              if (sib !== row) sib.classList.remove('selected');
            });
          }
          row.click();
        }
      }
    }
    syncing = false;
  }

  function detectPageSelection() {
    var radios = findQbRadios();
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].checked) continue;
      var row = radios[i].closest('.quantity-break-option, label, [class*="qb"]');
      var text = ((row && row.textContent) || '').toLowerCase();
      if (text.indexOf('get 3') !== -1 || text.indexOf('buy 1 get') !== -1 || text.indexOf('b1g3') !== -1) {
        return 'b1g3';
      }
      return 'buy1';
    }
    return 'b1g3';
  }

  function onAtcClick(e) {
    e.preventDefault();
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';
    var primary = findPrimaryAtc();
    if (primary) {
      try { primary.click(); } catch (err) {}
    }
    setTimeout(function () {
      if (!btn) return;
      btn.classList.remove('is-loading');
      btn.textContent = 'Add to Cart';
    }, 700);
  }

  var scrollRaf = 0;
  function onScroll() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      if (!bar) return;
      var qb = qs('.quantity-break-container, [class*="quantity-break"], [id^="qb-"]');
      var atc = findPrimaryAtc();
      var anchor = qb || atc;
      if (!anchor) {
        bar.classList.add('is-visible');
        bar.hidden = false;
        return;
      }
      var rect = anchor.getBoundingClientRect();
      var shouldShow = rect.bottom < 90;
      if (shouldShow === visible) return;
      visible = shouldShow;
      bar.hidden = false;
      bar.classList.toggle('is-visible', shouldShow);
    });
  }

  function bind() {
    bar = qs('[data-hestia-sticky-atc]');
    if (!bar) return;
    btn = qs('[data-hestia-sticky-atc-btn]', bar);
    opts = qsa('[data-hestia-sticky-opt]', bar);
    document.documentElement.classList.add('hestia-sticky-atc-ready');
    document.body.classList.add('hestia-sticky-atc-on');

    opts.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        selectBundle(el.getAttribute('data-hestia-sticky-opt'), false);
      }, { passive: false });
    });
    if (btn) btn.addEventListener('click', onAtcClick, { passive: false });

    // Keep sticky in sync when user taps on-page QB
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('quantity-break-input')) return;
      setStickyActive(detectPageSelection());
    }, true);

    setStickyActive(detectPageSelection());
    bar.hidden = false;
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
